export default __webpack_public_path__ + "static/media/team-3.d323b111.png";